import { Flex, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { BuyerBidDeclarationsDto } from "../../../autogen/bff-api";
import { EspdEmptyState, localizedText } from "../bid-detail/espdResponseRendering";
import { YesNoPill } from "./YesNoPill";

interface Props {
  declarations: BuyerBidDeclarationsDto | null | undefined;
}

export const FocusDeclarations = ({ declarations }: Props) => {
  const { t, i18n } = useTranslation();
  const items = declarations?.declarations ?? [];

  if (!declarations?.hasResponse || items.length === 0) return <EspdEmptyState />;

  return (
    <Stack spacing="3">
      <Text fontSize="sm" color="smMuted">
        {t("Declarations from the submitted ESPD response (Part II).")}
      </Text>
      {items.map((declaration) => (
        <Flex
          key={declaration.id}
          align="center"
          gap="4"
          px="4"
          py="3"
          borderWidth="1px"
          borderColor="smBorder"
          rounded="xl"
          bg="smBackground"
        >
          <Text fontSize="sm" color="smText" flex="1" minW="0">
            {localizedText(
              i18n.language,
              declaration.questionSource,
              declaration.questionTranslation,
              declaration.question,
            )}
          </Text>
          <YesNoPill value={declaration.answer ?? null} />
        </Flex>
      ))}
    </Stack>
  );
};
